import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { findingSettingCreate } from '../../../../../redux/actions/settingActions/findingSettingActions'
import { examFindingInfo, examFindings, examSelectedFinding } from '../../../../../redux/actions/exam/examFindingActions'
import { useActiveTestType } from '../../helpers/useActiveTestType'
import { submit } from 'redux-form'

function AddButton(props) {
  const { findings, activeFieldType, name, value, handleOnAddFindings, activeFieldKey, isHeaderModule } = props
  const activeTestType = useActiveTestType(name)
  const dispatch = useDispatch()

  const handleCreateFinding = async () => {
    // Finding created in settings
    let finding = await dispatch(findingSettingCreate({ name: value, test_type: activeTestType }))
    finding = finding.value.data.finding
    dispatch(examSelectedFinding(finding))
    dispatch(examFindings([]))
    // New finding added > show setting impression dropdown
    dispatch(examFindingInfo({ activeFieldType: activeTestType, dropdownType: 'impression_settings' }))
    handleOnAddFindings(value)
    if (isHeaderModule) {
      setTimeout(() => dispatch(submit('examHeaderForm')), 800);
    }
  }

  const getShow = () => {
    if (name.includes('hpis_attributes[')) {
      if (isHeaderModule) {
        return activeFieldKey === 'header.' + name
      }
      return activeFieldKey === name
    }
    return activeFieldType === activeTestType
  }
  return (
    <div>
      {(findings.length == 0 && (getShow())) &&
        <button type='button' id="add_finding_button" className='btn btn-primary rounded-0 py-3 px-4 d-flex align-items-center' onClick={handleCreateFinding}>
          <i className="las la-undo mr-2"></i> Add
        </button>
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { examFinding } = state

  return {
    findings: examFinding.findings,
    activeFieldType: examFinding.activeFieldType,
    activeFieldKey: examFinding.activeFieldKey
  }
}

export default connect(mapStateToProps)(AddButton)